import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/web',
  routes: [{
      path: '*',
      redirect: '/zhiboxitong',
      mete: {
        title: "404",
        icon: "el-icon-location"
      }
    },
    {
      path: '/',
      redirect: '/zhiboxitong/zhiboxiaoshou',
      mete: {
        title: "首页",
        icon: "el-icon-location"
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/zhiboxitong/login')
    },
    //直播系统
    {
      path: '/zhiboxitong',
      name: 'zhiboxitong',
      component: () => import('@/zhiboxitong/zhiboxiaoshou')
    },
    //入网协议
    {
      path: '/zhiboxitong/ruwangxieyi',
      name: 'ruwangxieyi',
      component: () => import('@/zhiboxitong/ruwangxieyi')
    },
    //小程序
    {
      path: '/zhiboxitong/xiaochengxu',
      name: 'xiaochengxu',
      component: () => import('@/zhiboxitong/xiaochengxu')
    },
    {
      path: '/zhiboxitong/xiaochengxu/xiaochengxu_fabu',
      name: 'xiaochengxu_fabu',
      component: () => import('@/zhiboxitong/xiaochengxu_fabu')
    },
    {
      path: '/zhiboxitong/xiaochengxu/xiaochengxu_fabu2',
      name: 'xiaochengxu_fabu2',
      component: () => import('@/zhiboxitong/xiaochengxu_fabu2')
    },
    {
      path: '/zhiboxitong/xiaochengxu/xiaochengxu_fabu2xin',
      name: 'xiaochengxu_fabu2xin',
      component: () => import('@/zhiboxitong/xiaochengxu_fabu2xin')
    },
    {
      path: '/zhiboxitong/xiaochengxu/xiaochengxu_shangpin',
      name: 'xiaochengxu_shangpin',
      component: () => import('@/zhiboxitong/xiaochengxu_shangpin')
    },
    {
      path: '/zhiboxitong/xiaochengxu/xiaochengxu_shangpinfabu',
      name: 'xiaochengxu_shangpinfabu',
      component: () => import('@/zhiboxitong/xiaochengxu_shangpinfabu')
    },
    {
      path: '/zhiboxitong/xiaochengxu/xiaochengxu_shangpinfabuxin',
      name: 'xiaochengxu_shangpinfabuxin',
      component: () => import('@/zhiboxitong/xiaochengxu_shangpinfabuxin')
    },

    {
      path: '/zhiboxitong/xiaochengxu/xcxstorelist',
      name: 'zhiboxiaoshou',
      component: () => import('@/zhiboxitong/xcxstorelist')
    },
    {
      path: '/zhiboxitong/xiaochengxu/xcxallpage',
      name: 'xcxallpage',
      component: () => import('@/zhiboxitong/xcxallpage')
    },
    {
      path: '/zhiboxitong/xiaochengxu/gongxiang',
      name: 'gongxiang',
      component: () => import('@/zhiboxitong/gongxiang')
    },

    {
      path: '/zhiboxitong/zhiboxiaoshou',
      name: 'zhiboxiaoshou',
      component: () => import('@/zhiboxitong/zhiboxiaoshou')
    },

    {
      path: '/zhiboxitong/zhiboxiaoshou/xiaoshoutongji',
      component: () => import('@/zhiboxitong/baobiao/xiaoshoutongjistore'),
    },
    {
      path: '/zhiboxitong/zhiboxiaoshou/yuefenxiangqing',
      component: () => import('@/zhiboxitong/baobiao/yuefenxiangqingstore'),
    },

    {
      path: '/zhiboxitong/zhiboxiaoshou2',
      name: 'zhiboxiaoshou2',
      component: () => import('@/zhiboxitong/zhiboxiaoshou2')
    },
    {
      path: '/zhiboxitong/plugManage',
      name: 'zhiboxiaoshou',
      component: () => import('@/zhiboxitong/plugManage')
    },
    //分类
    {
      path: '/zhiboxitong/fenleiguanli',
      name: 'fenleiguanli',
      component: () => import('@/zhiboxitong/fenleiguanli')
    },
    //  评论
    {
      path: '/zhiboxitong/pinglunguanli',
      name: 'pinglunguanli',
      component: () => import('@/zhiboxitong/pinglunguanli')
    },
    {
      path: '/zhiboxitong/pinglunguanli/pinglunguanlilist',
      name: 'pinglunguanlilist',
      component: () => import('@/zhiboxitong/pinglunguanlilist')
    },


    {
      path: '/zhiboxitong/zhiboxiaoshou/zhiboxiaoshou_fabu',
      name: 'zhiboxiaoshou_fabu',
      component: () => import('@/zhiboxitong/zhiboxiaoshou_fabu')
    },
    {
      path: '/zhiboxitong/zhiboxiaoshou/zhiboxiaoshou_fabu2',
      name: 'zhiboxiaoshou_fabu2',
      component: () => import('@/zhiboxitong/zhiboxiaoshou_fabu2')
    },
    {
      path: '/zhiboxitong/zhiboxiaoshou/zhiboxiaoshou_shangpin',
      name: 'zhiboxiaoshou_shangpin',
      component: () => import('@/zhiboxitong/zhiboxiaoshou_shangpin')
    },
    {
      path: '/zhiboxitong/zhiboxiaoshou/zhiboxiaoshou_shangpinfabu',
      name: 'zhiboxiaoshou_shangpinfabu',
      component: () => import('@/zhiboxitong/zhiboxiaoshou_shangpinfabu')
    },
    {
      path: '/zhiboxitong/zhiboxiaoshou/zhiboxiaoshou_shangpinfabuxin',
      name: 'zhiboxiaoshou_shangpinfabuxin',
      component: () => import('@/zhiboxitong/zhiboxiaoshou_shangpinfabuxin')
    },

    {
      path: '/zhiboxitong/meitituiguang/zhiboxiaoshou_shangpinfabuduo',
      name: 'zhiboxiaoshou_shangpinfabuduo',
      component: () => import('@/zhiboxitong/zhiboxiaoshou_shangpinfabuduo')
    },
    {
      path: '/zhiboxitong/meitituiguang/zhiboxiaoshou_shangpinfabuduoxin',
      name: 'zhiboxiaoshou_shangpinfabuduoxin',
      component: () => import('@/zhiboxitong/zhiboxiaoshou_shangpinfabuduoxin')
    },

    {
      path: '/zhiboxitong/yongqianxuzhi',
      name: 'yongqianxuzhi',
      component: () => import('@/zhiboxitong/yongqianxuzhi')
    },

    {
      path: '/zhiboxitong/meitituiguang',
      name: 'meitituiguang',
      component: () => import('@/zhiboxitong/meitituiguang')
    },
    {
      path: '/zhiboxitong/meitituiguang/xiaoshoutongji',
      component: () => import('@/zhiboxitong/baobiao/xiaoshoutongji'),
    },
    {
      path: '/zhiboxitong/meitituiguang/yuefenxiangqing',
      component: () => import('@/zhiboxitong/baobiao/yuefenxiangqing'),
    },

    {
      path: '/zhiboxitong/meitituiguang/meitituiguang_fabu',
      name: 'meitituiguang_fabu',
      component: () => import('@/zhiboxitong/meitituiguang_fabu')
    },
    {
      path: '/zhiboxitong/meitituiguang/meitituiguang_fabu2',
      name: 'meitituiguang_fabu2',
      component: () => import('@/zhiboxitong/meitituiguang_fabu2')
    },
    {
      path: '/zhiboxitong/meitituiguang/meitituiguang_fabu3',
      name: 'meitituiguang_fabu3',
      component: () => import('@/zhiboxitong/meitituiguang_fabu3')
    },
    {
      path: '/zhiboxitong/dingdanguanli',
      name: 'dingdanguanli',
      component: () => import('@/zhiboxitong/dingdanguanli')
    },
    {
      path: '/zhiboxitong/shoukuanpeizhi',
      name: 'shoukuanpeizhi',
      component: () => import('@/zhiboxitong/shoukuanpeizhi')
    },
    {
      path: '/zhiboxitong/tousu',
      name: 'tousu',
      component: () => import('@/zhiboxitong/tousu')
    },
    {
      path: '/zhiboxitong/chuli',
      name: 'chuli',
      component: () => import('@/zhiboxitong/chuli')
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js